module.exports = __webpack_public_path__ + "static/dash-1-deed28a381c4f7031fe92270ecb22b61.png";